// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sidebar-selected-bg: #ffffff;
  /* Translucent-white hover surface — same value as the header selectors'
     resting chip (and the billing box), so the hover highlight stays subtle
     and consistent across the app. */
  --sidebar-hover-bg: rgba(255, 255, 255, 0.07);
  --sidebar-selected-text: #5616ea;
  --app-header-height: 56px;
  --app-sidebar-width: 248px;
}

body {
  margin: 0;
  font-family: "DM Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(244, 244, 244);
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.scf-logo {
  height: 40px;
  margin: 0;
  padding: 0;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.drawer-open, .drawer-closed {
  width: 200px;
}

.content {
  transition: margin-left 0.3s;
}

.shifted {
  margin-left: clamp(200px, 16%, 300px);
}

.date-logout-container {
  display: flex;
  align-items: center;
  gap: 25px;
  color: rgb(245, 245, 245);
  font-size: 22px;
  margin-left: 10px;
}

.language-options {
  background-color: rgb(245, 245, 245);
  border-radius: 5px;
  outline: none;
  border: none;
  font-weight: 600;
  padding-left: 5px;
  padding-right: 10px;
  color: #282c34;
  height: 26px;
}

.sidebar-toggle {
  border: None;
  background-color: transparent;
  font-size: 28px;
  color: white;
  transition: 0.3s ease;
  padding: 0px;
  margin: 0;
  cursor: pointer;
}

.sidebar-toggle:hover {
  scale: 1.15;
}

.sidebar-toggle-open {
  border: None;
  background-color: transparent;
  color: black;
  cursor: pointer;
  padding-left: 20px;
  margin-top: 10px;
  font-size: 30px;
}

.menu-shifted {
  color: transparent;
}

.overlay-open {
  display: none;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
}

.sidebar-content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.menu-list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.5) transparent;
  padding-bottom: 12px;
  padding-right: 4px;
}

.menu-list::-webkit-scrollbar {
  width: 8px;
}

.menu-list::-webkit-scrollbar-track {
  background: transparent;
}

.menu-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.38);
  border: 2px solid transparent;
  border-radius: 999px;
  background-clip: padding-box;
}

.menu-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.65);
  border: 2px solid transparent;
  background-clip: padding-box;
}

.administration-bottom-items {
  text-align: left;
  margin-bottom: 20px;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  width: 100%;
  align-items: left;
  gap: 5px;
}

.administration-item {
  display: flex;
  width: 90%;
  margin: 0 auto;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
  background-color: transparent;
  color: white;
  font-size: 1.1rem;
  gap: 5px;
  border-radius: 8px;
}

.administration-item:hover {
  background-color: var(--sidebar-hover-bg);
}

.administration-item.selected {
  background-color: var(--sidebar-selected-bg);
  color: var(--sidebar-selected-text);
  font-weight: bold;
}

.administration-item.selected .admin-icon {
  color: var(--sidebar-selected-text);
}

.admin-icon-container {
  padding-left: 15px;
  width: 35px;
}

.admin-icon {
  font-size: 1.3rem;
  margin-top: 2px;
}

.sidebar-footer-links {
  display: flex;
  justify-content: left;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 0.5rem;
  gap: 25px;
}

.sidebar-footer-links a {
  color: white;
  font-size: 11px;
}

@media (max-width: 768px) {
  .overlay-open {
    display: block;
  }

  .sidebar-toggle-open {
    padding-left: 20px;
    margin-top: 15px;
  }

  .content {
    margin-left: 0;
  }

  .language-options {
    height: 30px;
    font-size: 14px;
  }
}

/* ── App shell: fixed header + fixed sidebar + flowing content ───────── */
.app-shell {
  min-height: 100vh;
  min-height: 100dvh; /* dvh excludes mobile browser chrome → the shell never exceeds the visible viewport, so pages aren't phantom-scrollable app-wide */
}

.app-content {
  margin-left: var(--app-sidebar-width, 248px);
  padding-top: var(--app-header-height, 56px);
  min-height: 100vh;
  min-height: 100dvh; /* dvh excludes the mobile browser chrome → no phantom scroll space below short/fixed-height pages (e.g. the AI Studio) */
  box-sizing: border-box;
}

.app-sidebar-backdrop {
  display: none;
}

@media (max-width: 768px) {
  .app-content {
    margin-left: 0;
  }
  .app-sidebar-backdrop.show {
    display: block;
    position: fixed;
    top: var(--app-header-height, 56px);
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1045;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B;;qCAEmC;EACnC,6CAA6C;EAC7C,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,qDAAqD;EACrD,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,2EAA2E;AAC3E;EACE,iBAAiB;EACjB,kBAAkB,EAAE,mIAAmI;AACzJ;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB,EAAE,yHAAyH;EAC7I,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,eAAe;IACf,mCAAmC;IACnC,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,aAAa;EACf;AACF","sourcesContent":[":root {\r\n  --sidebar-selected-bg: #ffffff;\r\n  /* Translucent-white hover surface — same value as the header selectors'\r\n     resting chip (and the billing box), so the hover highlight stays subtle\r\n     and consistent across the app. */\r\n  --sidebar-hover-bg: rgba(255, 255, 255, 0.07);\r\n  --sidebar-selected-text: #5616ea;\r\n  --app-header-height: 56px;\r\n  --app-sidebar-width: 248px;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: rgb(244, 244, 244);\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n.scf-logo {\r\n  height: 40px;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.drawer-open, .drawer-closed {\r\n  width: 200px;\r\n}\r\n\r\n.content {\r\n  transition: margin-left 0.3s;\r\n}\r\n\r\n.shifted {\r\n  margin-left: clamp(200px, 16%, 300px);\r\n}\r\n\r\n.date-logout-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 25px;\r\n  color: rgb(245, 245, 245);\r\n  font-size: 22px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.language-options {\r\n  background-color: rgb(245, 245, 245);\r\n  border-radius: 5px;\r\n  outline: none;\r\n  border: none;\r\n  font-weight: 600;\r\n  padding-left: 5px;\r\n  padding-right: 10px;\r\n  color: #282c34;\r\n  height: 26px;\r\n}\r\n\r\n.sidebar-toggle {\r\n  border: None;\r\n  background-color: transparent;\r\n  font-size: 28px;\r\n  color: white;\r\n  transition: 0.3s ease;\r\n  padding: 0px;\r\n  margin: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.sidebar-toggle:hover {\r\n  scale: 1.15;\r\n}\r\n\r\n.sidebar-toggle-open {\r\n  border: None;\r\n  background-color: transparent;\r\n  color: black;\r\n  cursor: pointer;\r\n  padding-left: 20px;\r\n  margin-top: 10px;\r\n  font-size: 30px;\r\n}\r\n\r\n.menu-shifted {\r\n  color: transparent;\r\n}\r\n\r\n.overlay-open {\r\n  display: none;\r\n  position: fixed;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 50;\r\n}\r\n\r\n.sidebar-content {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.menu-list {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  scrollbar-gutter: stable;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.5) transparent;\r\n  padding-bottom: 12px;\r\n  padding-right: 4px;\r\n}\r\n\r\n.menu-list::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.menu-list::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.menu-list::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.38);\r\n  border: 2px solid transparent;\r\n  border-radius: 999px;\r\n  background-clip: padding-box;\r\n}\r\n\r\n.menu-list::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.65);\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n}\r\n\r\n.administration-bottom-items {\r\n  text-align: left;\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n  flex: 0 0 auto;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  align-items: left;\r\n  gap: 5px;\r\n}\r\n\r\n.administration-item {\r\n  display: flex;\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  align-items: center;\r\n  padding-top: 8px;\r\n  padding-bottom: 8px;\r\n  cursor: pointer;\r\n  background-color: transparent;\r\n  color: white;\r\n  font-size: 1.1rem;\r\n  gap: 5px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.administration-item:hover {\r\n  background-color: var(--sidebar-hover-bg);\r\n}\r\n\r\n.administration-item.selected {\r\n  background-color: var(--sidebar-selected-bg);\r\n  color: var(--sidebar-selected-text);\r\n  font-weight: bold;\r\n}\r\n\r\n.administration-item.selected .admin-icon {\r\n  color: var(--sidebar-selected-text);\r\n}\r\n\r\n.admin-icon-container {\r\n  padding-left: 15px;\r\n  width: 35px;\r\n}\r\n\r\n.admin-icon {\r\n  font-size: 1.3rem;\r\n  margin-top: 2px;\r\n}\r\n\r\n.sidebar-footer-links {\r\n  display: flex;\r\n  justify-content: left;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  margin-top: 0.5rem;\r\n  gap: 25px;\r\n}\r\n\r\n.sidebar-footer-links a {\r\n  color: white;\r\n  font-size: 11px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .overlay-open {\r\n    display: block;\r\n  }\r\n\r\n  .sidebar-toggle-open {\r\n    padding-left: 20px;\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .content {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .language-options {\r\n    height: 30px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n/* ── App shell: fixed header + fixed sidebar + flowing content ───────── */\r\n.app-shell {\r\n  min-height: 100vh;\r\n  min-height: 100dvh; /* dvh excludes mobile browser chrome → the shell never exceeds the visible viewport, so pages aren't phantom-scrollable app-wide */\r\n}\r\n\r\n.app-content {\r\n  margin-left: var(--app-sidebar-width, 248px);\r\n  padding-top: var(--app-header-height, 56px);\r\n  min-height: 100vh;\r\n  min-height: 100dvh; /* dvh excludes the mobile browser chrome → no phantom scroll space below short/fixed-height pages (e.g. the AI Studio) */\r\n  box-sizing: border-box;\r\n}\r\n\r\n.app-sidebar-backdrop {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .app-content {\r\n    margin-left: 0;\r\n  }\r\n  .app-sidebar-backdrop.show {\r\n    display: block;\r\n    position: fixed;\r\n    top: var(--app-header-height, 56px);\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.45);\r\n    z-index: 1045;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
